import { ConferenceApi } from '@/services'
import Vue from 'vue'

const state = {
  conference: null,
  participants: []
}

const mutations = {
  setConference(state, conference) {
    state.conference = conference
  },
  setParticipants(state, participants) {
    state.participants = participants
  },
  setLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  setLoaded(state, isLoaded) {
    state.isLoaded = isLoaded
  }
}

const actions = {
  reset({ commit }) {
    commit('setLoaded', false)
    commit('setConference', null)
    commit('setParticipants', [])
  },
  onAuthChange: ({ dispatch }, { isPracticeChanged, isNewUser }) => {
    if (isPracticeChanged) {
      dispatch('reset')
    }
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
